import { useState, useCallback } from 'react';

const STORAGE_KEY = 'pwa-install-prefs';

interface InstallPreferences {
  bannerDismissedAt: number | null;
  modalShown: boolean;
}

const getPreferences = (): InstallPreferences => {
  try {
    const stored = localStorage.getItem(STORAGE_KEY);
    if (stored) return JSON.parse(stored);
  } catch {}
  return { bannerDismissedAt: null, modalShown: false };
};

const savePreferences = (prefs: InstallPreferences) => {
  try {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(prefs));
  } catch {}
};

export const useInstallPreferences = () => {
  const [preferences, setPreferences] = useState<InstallPreferences>(getPreferences);

  const dismissBanner = useCallback(() => {
    const updated = { ...preferences, bannerDismissedAt: Date.now() };
    savePreferences(updated);
    setPreferences(updated);
  }, [preferences]);

  const markModalShown = useCallback(() => {
    const updated = { ...preferences, modalShown: true };
    savePreferences(updated);
    setPreferences(updated);
  }, [preferences]);

  const shouldShowBanner = useCallback(() => {
    if (!preferences.bannerDismissedAt) return true;
    const sevenDays = 7 * 24 * 60 * 60 * 1000;
    return Date.now() - preferences.bannerDismissedAt > sevenDays;
  }, [preferences]);

  return { preferences, dismissBanner, markModalShown, shouldShowBanner };
};
